import { DEFAULT_LANGUAGE, getLanguageConfig, LanguageCode } from 'mt-shared';

// Needs to be maintained in locale-detection.ejs as well
export function mapLocale(locale: string): LanguageCode {
  const fromConfig = getLanguageConfig(locale as LanguageCode);
  if (fromConfig) return fromConfig.code;

  if (/^(en|en-US)$/i.test(locale)) return 'en-US';
  if (/^(fr|fr-CA)$/i.test(locale)) return 'fr-CA';
  if (/^(es|es-MX)$/i.test(locale)) return 'es-MX';

  return DEFAULT_LANGUAGE;
}
